import {ChangeDetectorRef, Component} from '@angular/core';
import {StoreSelectorsService} from "../../services";
import {actionAccountPollLiveChatRequest} from "../../store/actions/user.actions";
import * as _ from 'lodash';
import {Compbaser} from "../compbaser";
import {isHostDev, isHostLocal} from "../../common";

/** always paste here from index.html of website to generate a new json data file **/
const currentIndexHtmlMenu = `
<ul class="navigation-menu nav">
                        <li class="menu-item-has-children"><a href="_html/products.html">products</a>
                            <ul class="submenu">
                                <li><a href="https://galaxy.signage.me/signstudio/getstarted/template"><span class="signNow">Login | Sign up</span></a></li>
                                <li><a href="_html/mediacloud.html">mediaCLOUD</a></li>
                                <li><a href="_html/mediaplayer.html">mediaPLAYERs</a></li>
                                <li><a href="_html/mediaserver.html">mediaSERVER</a></li>
                                <li><a href="_html/mediahybrid.html">mediaHYBRID</a></li>
                                <li><a href="_html/interactive_digital_signage.html">mediaTOUCH</a></li>
<!--                            <li><a href="_html/digital_signage_touch_screen.html">mediaFRAME</a></li> -->
                                <li><a href="_html/content_creation.html">mediaSTART</a></li>
                            </ul>
                        </li>
                        <li class="menu-item-has-children"><a href="_html/enterprise.html">upgrade</a>
                            <ul class="submenu">
                                <li><a href="https://galaxy.signage.me/signstudio/shopping-cart/price">prices</a></li>
                                <li><a href="_html/benefits.html">benefits</a></li>
                                <li><a href="_html/media_store.html">smart components</a></li>
                            </ul>
                        </li>
                        <li class="menu-item-has-children"><a href="_html/technology.html">technology</a>
                            <ul class="submenu">
                                <li><a href="https://galaxy.signage.me/signstudio/shopping-cart/downloads">get studio/player</a></li>
<!--                                <li><a href="_html/signagestudio.html">LegacyStudio</a></li>-->
                                <li><a href="_html/signstudio.html">SignStudio</a></li>
                                <li><a href="_html/signageplayer.html">SignPlayer</a></li>
<!--                                <li><a href="http://interactive.digitalsignage.com">Interactive signage</a></li>-->
                                <li><a href="_html/chrome_os.html">Chrome OS | Flex</a></li>
                                <li><a href="_html/remotetouch.html">RemoteTouch</a></li>
                                <!-- <li><a href="_html/remotevalues.html">RemoteValues</a></li> -->
                                <li><a href="_html/internet_of_things_digital_signage.html">internet of things</a></li>
                                <li><a href="_html/digital_signage_ad_network.html">mediaADNET</a></li>
                                <li><a href="_html/workplace-experience.html">workspace experience</a></li>
                                <li><a href="_html/digital_signage_dashboard.html">StudioDashboard</a></li>
                                <li><a href="_html/location_based.html">location based</a></li>
                                <li><a href="http://www.fasterq.com">customer line management</a></li>
                                <li><a href="_html/digital-menu-board.html">digital menu board</a></li>
                                <li><a href="_html/digital-signage-installation.html">on site installation</a></li>
                                <li><a href="_html/open_source_digital_signage.html">development</a></li>
                            </ul>
                        </li>
                        <li class="menu-item-has-children"><a href="_html/support.html">support</a>
                            <ul class="submenu">
                                <li><a href="https://galaxy.signage.me/signstudio/shopping-cart/downloads">downloads</a></li>
<!--                            <li><a href="_html/webinar_registration.html">webinar</a></li>-->
<!--                            <li><a href="_html/signage_video.html">video tutorials</a></li>-->
                                <li><a href="https://galaxy.signage.me/signstudio/shopping-cart/helpdesk">video tutorials</a></li>
                                <li><a href="_html/faqs.html">faqs</a></li>
                                <li><a href="_html/live_chat.html">live chat</a></li>
<!--                                <li><a href="https://www.digitalsignage.com/support/upload/index.php?/Knowledgebase/List">knowledge base</a></li>-->
<!--                                <li><a href="http://docs.digitalsignage.com">docs</a></li>-->
<!--                                <li><a href="http://script.digitalsignage.com/forum/index.php">forum</a></li>-->
                                <li><a href="_html/contactv3.html">contact us</a></li>
                            </ul>
                        </li>
                    </ul>
`;

@Component({
    selector: 'app-nav-drop-menu',
    styleUrls: [`./nav-drop-menu.component.scss`],
    templateUrl: './nav-drop-menu.component.html'
})
export class NavDropMenuComponent extends Compbaser {

    // menu = [];
    jsonMenu;
    jsonMenuList = [];
    liveChatStatus = false;
    constructor(private storeSelector: StoreSelectorsService, private cd: ChangeDetectorRef) {
        super();
        this.buildDropMenu();
        this.storeSelector.dispatch(actionAccountPollLiveChatRequest(''));
        this.jsonMenu.forEach((menu) => {
            const buttonized = menu.buttonized;
            if (!_.isNull(buttonized)) {
                const menus: Array<any> = menu[menu.name];
                menus.forEach((c) => this.jsonMenuList.push(c));
            }
        });
        this.cod(
            this.storeSelector.getLiveChatStatusV2().subscribe((i_status) => {
                this.liveChatStatus = i_status.liveStatusV2 > 0;
                this.cd.markForCheck();
            })
        );

    }

    private buildDropMenu(){
        this.jsonMenu = [];
        let lastHeader = '';
        currentIndexHtmlMenu.split(/\r?\n/).forEach((line) => {
            if (line.indexOf('<!--') > -1) return;
            if (line.indexOf('<li') > -1) {
                line = line.trim();
                line = line.replace('"_html', '"https://digitalsignage.com/_html');
                if (line.indexOf('menu-item-has-children') > -1) {
                    const re = new RegExp(/.html">(.*)+?<\/a>/);
                    const match = line.match(re);
                    const header = match[1];
                    lastHeader = match[1];
                    this.jsonMenu.push({
                        name: header,
                        buttonized: false,
                        [header]: []
                    });
                } else {
                    const r1 = new RegExp(/href="(.*?)(">)/);
                    const urlMatch = line.match(r1);
                    const link = urlMatch[1];
                    const r2 = new RegExp(/class=".*">(.*)(<\/span)/);
                    const matchName = line.match(r2);
                    if (matchName) {
                        this.jsonMenu[this.jsonMenu.length - 1][lastHeader].push({name: matchName[1], link});
                    } else {
                        const t = new RegExp(/">(.*)<\/a>/);
                        const match = line.match(t);
                        this.jsonMenu[this.jsonMenu.length - 1][lastHeader].push({name: match[1], link});
                    }
                }
            }
        });
    }

    openUrl(item) {
        window.open(item, '_blank');
    }
}


